import { useTranslation } from 'react-i18next';
import { Layout } from '../components/Layout';
import GoogleReviews from '../components/GoogleReviews';
import { Star } from 'lucide-react';

const ReviewsPage = () => {
  const { i18n } = useTranslation();

  return (
    <Layout>
      <div className="min-h-screen bg-[#F9FAFB] pt-24 pb-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Hero */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Star className="w-10 h-10 text-yellow-400 fill-yellow-400" />
              <h1 className="font-serif text-4xl md:text-5xl text-[#181B1F]">
                {i18n.language === 'fr' ? 'Avis Clients' : 'Customer Reviews'}
              </h1>
            </div>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              {i18n.language === 'fr'
                ? 'Découvrez ce que nos clients pensent de nos services de location de voitures à Genève.'
                : 'Discover what our customers think about our car rental services in Geneva.'}
            </p>
          </div>

          {/* Google Reviews Component */}
          <GoogleReviews variant="full" maxReviews={10} />
        </div>
      </div>
    </Layout>
  );
};

export default ReviewsPage;
